import membership_background from 'assets/membership_background.jpeg';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { book_with_benefits_description, book_with_benefits_title, lowest_price_description, lowest_price_title } from 'data/translationKeys';
import Image from 'next/future/image';
import React, { FC } from 'react';

export const MembershipHero: FC = () => {
  const lowest_price_title_text = useLocalised(lowest_price_title);
  const lowest_price_description_text = useLocalised(lowest_price_description);
  const book_with_benefits_title_text = useLocalised(book_with_benefits_title);
  const book_with_benefits_description_text = useLocalised(
    book_with_benefits_description
  );

  return (
    <div className="membership-hero">
      <div className="membership-hero__image">
        <Image
          src={membership_background}
          alt="background image"
          // width={1300}
          width={2560}
          priority
        />
      </div>
      <div className="membership-hero__container">
        <div className="membership-hero__card membership-hero__price">
          <div className="membership-hero__card-title">
            {lowest_price_title_text}
          </div>
          <div className="membership-hero__card-text">
            {lowest_price_description_text}
          </div>
        </div>
        <div className="membership-hero__card membership-hero__benefits">
          <div className="membership-hero__card-title">
            {book_with_benefits_title_text}
          </div>
          <div className="membership-hero__card-text">
            {book_with_benefits_description_text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipHero;
